import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseUpdatePrivateCompanyLeadContractFee {
  privateCompanyLeadId?: string,
  onSuccess?: (response: any) => void,
  onError?: (error: any) => void
}

export const useUpdatePrivateCompanyLeadContract = ({ privateCompanyLeadId, onSuccess, onError }: UseUpdatePrivateCompanyLeadContractFee) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['updatePrivateCompanyLeadContractFee'],
    mutationFn: async (data: { 
      contract_fees_attributes?: { id: string, value?: string, main_fee?: boolean }, 
      default_fuel_price_rule?: string 
    }) => {
      const private_company_lead: any = {
        contract_attributes: {}
      }

      if (data.contract_fees_attributes) { private_company_lead.contract_attributes.contract_fees_attributes = data.contract_fees_attributes }
      if (data.default_fuel_price_rule) private_company_lead.contract_attributes.default_fuel_price_rule = data.default_fuel_price_rule

      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}
